import { Navigate, useParams } from 'react-router-dom'

const LegacyTypeViewRedirect = () => {
  const { entityTypeId } = useParams()
  if (!entityTypeId) return <Navigate to="/types" replace />
  return <Navigate to={`/types/${entityTypeId}`} replace />
}

const LegacyTypeEditRedirect = () => {
  const { entityTypeId } = useParams()
  if (!entityTypeId) return <Navigate to="/types" replace />
  return <Navigate to={`/types/${entityTypeId}/edit`} replace />
}

const LegacyTypeNewRedirect = () => <Navigate to="/types/new" replace />

export { LegacyTypeViewRedirect, LegacyTypeEditRedirect, LegacyTypeNewRedirect }
